import { Component, computed, inject, Input, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import { OffcanvasService } from '@coreui/angular';
import { faker } from '@faker-js/faker';
import {  Unit, BizEntityFunctionTypes, FieldTypes, ItxnRelationshipLog, IAdditionalInfo, BizEntityTypeCategory, IBizEntity, IBizEntityType, IHierarchyItem } from '@optima-stride-ai/core';
import { ViewKind, CardSize } from '@optima-stride-ai/core/type-based-views';
import { BasePaginationController, ContextMenuClickInfo, ContextMenuItem, IAddButtonOptions, IGraphConfig, IPaginationReqMessage, Page, ToastService, ContextMenuComponent, MindMapLayout, ILayout, ExplorerHierarchyMoveHandler, IHierarchyMove } from '@optima-stride-ai/optima-components';
import { Explorer, IColsData, IExplorerAttributes, IExplorerContentAttributes, IExplorerContentGraphAttributes, IExplorerHeaderAttributes, IExplorerNavAttributes, IGridItemContent, IListViewColHeader, IListViewItem, IEntityHostGridItem, } from '@optima-stride-ai/optima-components';
// Unused imports - commented for future use
// import { Chart } from 'chart.js';
// import { SettingsService } from '@optima-stride-ai/core';
import { filter, Subscription, timeout } from 'rxjs';
import { DeliverableStateStoreService } from '../../deliverables/deliverable-state-store/deliverable-state-store.service';
import { IDeliverable } from '../../deliverables/deliverable.model';
import { KpiStateStoreService } from '../../kpi/KPI-state-stores/kpi-state-store.service';
import { ObjectiveStateStoreService } from '../../objective/objective-state-store/objective-state-store.service';
import { IObjective } from '../../objective/objective.model';
import { MeasureLogStateStoreService } from '../../transaction-log/measure-log-state-store/measure-log-state-store.service';
import { MeasuresStateStoreService } from '../../transaction(Measure)/measure-state-store/measures-state-store.service';
import { IMeasure } from '../../transaction(Measure)/measure.model';
import { BizEntityChildrenStatusStoreService, AppTagService, EntityBottomOffCanvasService, EntityViewHostComponent } from '@optima-stride-ai/optima-app-framework';
import { NotesPopoverService } from '../../notes/services/notes-popover/notes-popover.service';
import { BizEntityTypeStateStoreService } from '@optima-stride-ai/optima-app-framework';
import { BizEntityStateStoreService } from '@optima-stride-ai/optima-app-framework';
import { BizEntityFormService } from '@optima-stride-ai/optima-app-framework';
import { UtilService } from '../../utils/util.service';
import { ExplorerPaginationConfig } from '../../utils/explorer-pagination.config';
import { ExplorerContentDropMode } from '../../utils/explorer-content-drop-mode';
import { createHierarchyMovePayload, resolveHierarchyRecord } from '../../utils/explorer-hierarchy-persistence';
import { refreshExplorer } from '../../utils/explorer-nav-selection';
import { refreshCreatedExplorerEntity, refreshStrategyExplorerNav as refreshExplorerNav,
  strategyEntityCreated$, isStrategyCreationCompletion } from './strategy-explorer-creation';
import { consumeExplorerReveal, ExplorerReveal, ExplorerRoutes } from '../../utils/explorer-reveal';
import { getColHeaderForDeliverableListView, getListViewItemsForDeliverable, handleDeliverableProgressSaveClicked, shouldCreateDeliverableProgressLogDirectly } from '../../deliverables/deliverable-list-view';
import { ColumnCanonicalKeys, getColHeadersForBizEntity, getCombinedColHeadersForBizEntities, getLayoutItemsForGraphView, getListViewItemsForBizEntities, IInlineNameEditHandlers, normalizeListItems } from '../explorer-list-view';
import { filterBizEntitiesForStrategyExplorer, filterBizEntityTypesForStrategyExplorer, isExcludedFromStrategyExplorer } from '../biz-entity-category-filters';
import { ContextMenuService } from '../../context-menu/context-menu';
import { LinkedEntityPickerService } from '../../linked-content-panel/linked-entity-picker/linked-entity-picker.service';
import { AppStateService } from '../../state/app-state';
import { FormStates, getOffCanvasComponentForBizEntityCategory, OffCanvasComponents, OffCanvasRightContentTypes } from '../../off-canvas/off-canvas-service/off-canvas-form.service';
import { IconModule } from '@coreui/icons-angular';
import { OffCanvasCollectiveComponent } from "../../off-canvas/off-canvas-form/off-canvas-collective/off-canvas-collective.component";
import { getKeyOfEnumValue, StateStoreUtilsService } from '../../state/state-utils/utility';
import { createTxnLogJSON } from '../../transaction-log/txn-log';
import { TieredMenu } from "primeng/tieredmenu";
import { RelationshipStateStoreService } from '@optima-stride-ai/optima-app-framework';
import { QuickActionService } from '../../quick-action/quick-action-state-store/quick-action-state-store.service';
import { openOffCanvas, OffCanvasIDsInDefaultLayout, getOffCanvasIdFromLevel, OffCanvasPlacement, OptimaOffCanvasService } from '@optima-stride-ai/optima-components';
import { BenBizEntityProgressStatusStoreService } from '../ben-biz-entity-progress-status-store/ben-biz-entity-progress-status-store.service';
import { OptimaDefaultModalService } from '../../modal/modal.service';
import { launchTransactionLogFormDialog } from '../../modal/modal';
import { markDeliverableAsComplete } from '../../deliverables/mark-deliverable-as-complete';
import { BenzaitenCardEvents } from '../../entity-view/Basic entites/card/medium/benzaiten-card-medium.events';

@Component({
  selector: 'app-strategy-explorer',
  imports: [Explorer],
  templateUrl: './strategy-explorer.component.html',
  styleUrl: './strategy-explorer.component.sass',
})
export class StrategyExplorerComponent extends BasePaginationController<IBizEntity> implements OnInit, OnDestroy {

  // ===================== Component Properties & ViewChild =====================
  
  @ViewChild('strategyExplorer') explorerComponent!: Explorer;
  @Input('isInModal') isInModal: boolean = false;
  
  // ===================== Explorer Attributes Configuration =====================
  
  subHeaderAttributes: IExplorerHeaderAttributes = {
    search: true,
    filter: false,
    add: true,
    view: true,
    sideBar: true,
    addWithOptions: true,
    addButtonOptions: [],
    breadCrumbToggle: true,
    nextDisable: false,
    previouseDisable: false,
    appliedFilterCount: 0,
    graphView: false,
  };

  explorerNavAttributes: IExplorerNavAttributes = {
    data: [],
    isNavigable: false,
    enableDragDrop: true,
    selectOnExpand: true,
  };

  explorerContentAttributes: IExplorerContentAttributes = {
    data: [],
    listData: {
      title: '',
      colHeaders: [],
      items: [],
    },
    currentSelectedItem: '',
  };
  
  explorerContentGraphAttributes: IExplorerContentGraphAttributes = {
    data: [],
    graphConfig: {
      cardLayout:[],
    },
    layout: MindMapLayout.Left
  };

  explorerAttributes: IExplorerAttributes = {
    data: [],
    subHeaderAttributes: this.subHeaderAttributes,
    explorerNavAttributes: this.explorerNavAttributes,
    explorerContentAttributes: this.explorerContentAttributes,
    explorerContentGraphAttributes: this.explorerContentGraphAttributes,
    contentDropMode: ExplorerContentDropMode.Hierarchy,
    isInModal: this.isInModal,
    contextMenuItems: []
  };

  
  dataRefreshedToken: string = '';
  subHeaderOptions: IAddButtonOptions[] = [];
  private contextMenuItems: ContextMenuItem[] = [];

  // ===================== Service Injections =====================
  
  private readonly offCanvasFormService = inject(OptimaOffCanvasService);
  private readonly offCanvasServiceRef = inject(OffcanvasService);
  private readonly entityBottomOffCanvasService = inject(EntityBottomOffCanvasService);
  private readonly toastService = inject(ToastService);
  private readonly bizEntityTypesStateStoresService = inject(BizEntityTypeStateStoreService);
  private readonly bizEntityStateStoreService = inject(BizEntityStateStoreService);
  private readonly bizEntityFormService = inject(BizEntityFormService);
  private readonly deliverableStateStoreService = inject(DeliverableStateStoreService);
  private readonly objectiveStateStoreService = inject(ObjectiveStateStoreService);
  private readonly measuresStateStoreService = inject(MeasuresStateStoreService);
  private readonly measureLogStateStoreService = inject(MeasureLogStateStoreService);
  private readonly benBizEntityProgressStatusStoreService = inject(BenBizEntityProgressStatusStoreService);
  private readonly bizEntityChildrenStatusStoreService = inject(BizEntityChildrenStatusStoreService);
  private readonly kpiStateStoreService = inject(KpiStateStoreService);
  private readonly utilService = inject(UtilService);
  private readonly contextMenuService = inject(ContextMenuService);
  private readonly linkedEntityPickerService = inject(LinkedEntityPickerService);
  private readonly notesPopover = inject(NotesPopoverService);
  private readonly relationshipStateStoreService = inject(RelationshipStateStoreService);
  private readonly appStateService = inject(AppStateService);
  private readonly stateStoreUtilsService = inject(StateStoreUtilsService);
  readonly quickActionMockService = inject(QuickActionService)
  readonly appTagService = inject(AppTagService);
  readonly optimaDefaultModalService = inject(OptimaDefaultModalService);
  // ===================== Data Properties =====================
  
  strategyBenBizEntityData: IBizEntity[] = [];
  bizEntities: IBizEntity[] = [];
  bizEntityTypes: IBizEntityType[] = [];
  deliverables: IDeliverable[] = [];
  objectives: IObjective[] = [];
  measureData: IMeasure[] = [];
  renderedData: IBizEntity[] = [];
  
  // ===================== State Flags & Tracking =====================
  
  private _isActiveComponent = false;
  private _selectedEntity: IBizEntity | null = null;
  private lastVisitedItemId = '';
  private allDataLoaded = false;
  private contentRequestSequence = 0;
  private readonly explorerReveal = new ExplorerReveal({
    route: ExplorerRoutes.Strategy,
    state: () => this.appStateService,
    explorer: () => this.explorerComponent,
    entities: () => this.strategyBenBizEntityData,
    fetch: (ids, ancestorsOf) => this.bizEntityStateStoreService.getState(
      this.bizEntityTypesStateStoresService, this.bizEntityChildrenStatusStoreService, ids, undefined, ancestorsOf),
    merge: entities => this.appendCachedChildren(entities),
    openFolder: id => this.navItemClicked(id),
  });
  public readonly contentItemCountPerPage = ExplorerPaginationConfig.ContentItemCountPerPage;
  // Client-side category filtering drops some raw rows, so the raw backend offset can drift
  // ahead of the filtered item count the pagination buffer tracks; keyed per parent id ('' = root).
  private readonly rawOffsetByParent = new Map<string, number>();
  private hierarchyMoveBusy = false;
  private hierarchyMoveUncertain = false;
  private readonly hierarchyWritesAttempted = new WeakSet<IHierarchyMove>();
  private readonly hierarchyReadParents = new WeakMap<IHierarchyMove, IBizEntity['parentId']>();
  private readonly hierarchyOriginalParents = new WeakMap<IBizEntity, IBizEntity['parentId']>();
  readonly hierarchyMoveHandler = new ExplorerHierarchyMoveHandler({
    findEntity: (id: string) => this.findLoadedEntity(id),
    persistMove: (move: IHierarchyMove) => this.persistHierarchyMove(move),
    reconcileMove: async (move: IHierarchyMove) => {
      if (!this.hierarchyWritesAttempted.has(move)) {
        this.toastService.toast('The move was not submitted. Refresh the item and try again.');
        return this.hierarchyReadParents.has(move)
          ? this.hierarchyReadParents.get(move)!
          : this.hierarchyOriginalParents.has(move.entity)
            ? this.hierarchyOriginalParents.get(move.entity)!
            : move.previousParentKey;
      }
      const entity = await this.loadHierarchyRecord(move);
      if ((entity.parentId?.toString() ?? '') !== move.nextParentKey) {
        this.toastService.toast('The move was not saved as requested. The current parent has been reloaded.');
      }
      return entity.parentId;
    },
    onMoveUncertain: () => {
      this.hierarchyMoveUncertain = true;
      this.toastService.toast('The move could not be confirmed. Reload before moving more items.');
    },
    fetchAncestry: (parentId: string) => this.bizEntityStateStoreService.getState(
      this.bizEntityTypesStateStoresService,
      this.bizEntityChildrenStatusStoreService,
      undefined,
      undefined,
      parentId
    ),
    onMoveCommitted: (move: IHierarchyMove) => this.refreshHierarchyAfterMove(move),
    onMoveFailed: (move: IHierarchyMove, error: unknown) => {
      console.error(`Failed to move entity ${move.entityId} to parent ${move.nextParentKey}`, error);
      this.toastService.toast('Drag and drop failed. Please try again.');
      refreshExplorerNav(this.explorerComponent);
    },
    setBusy: (isBusy: boolean) => {
      this.isLoading.set(isBusy);
      if (isBusy) {
        this.hierarchyMovesInFlight++;
        return;
      }
      // Deferred so a store `changed` emitted right after the save is still skipped.
      setTimeout(() => this.hierarchyMovesInFlight--);
    },
  });
  private readonly deletedEntityIds = new Set<string>();
  // A move refreshes the affected parents itself, so store-triggered full reloads are skipped meanwhile.
  private hierarchyMovesInFlight = 0;
  private readonly skipDuringHierarchyMove = filter(() => this.hierarchyMovesInFlight === 0);
  
  private dataLoadingFlags = {
    bizEntities: false,
    deliverables: false,
    objectives: false,
    measures: false
  };
  
  private dataLoadedOnce = {
    deliverables: false,
    objectives: false,
    measures: false
  };

  // ===================== Subscriptions =====================
  
  private bizEntityStoreSubscription: Subscription | undefined;
  private deliverableStoreSubscription: Subscription | undefined;
  private objectiveStoreSubscription: Subscription | undefined;
  private bizEntityTypeSubscription: Subscription | undefined;
  private measureLogStoreSubscription: Subscription | undefined;
  private relationshipStoreSubscription: Subscription | undefined;
  private incomingSelectionSubscription: Subscription | undefined;
  /** Creation updates are independent of explicit navigation requests. */
  private creationSubscription: Subscription | undefined;
  /** Creation IDs whose legacy notification must not navigate this Strategy view. */
  private readonly creationSelectionIds = new Set<string>();
  private deleteCompletedSubscription: Subscription | undefined;

  // ===================== Constructor =====================
  
  constructor() {
    super();
    this.contextMenuService.onMenuClicked = () => {
      setTimeout(() => {
        if (this.appStateService.offCanvasRightContentType === OffCanvasRightContentTypes.BizEntityForms) {
          this.openBizEntityFormInOffCanvas();
        } else if (this.appStateService.offCanvasRightContentType === OffCanvasRightContentTypes.DetailForm) {
          this.openDetailOffCanvas();
        } else {
          this.openOthersInRightOffCanvas();
        }
      });
    };
    
    this.contextMenuService.onPinToQuickActionClicked = () => {
      setTimeout(() => {
        this.addToQuickActionClicked();
      });
    };

    this.contextMenuService.markDeliverableAsCompleteEvent.subscribe((bizEntity: IBizEntity) => {
      setTimeout(() => {
        // Implement the logic to mark the deliverable as complete
        this.markDeliverableAsComplete(bizEntity);
      });
    });
  }

  // ===================== Lifecycle Hooks =====================

  ngOnInit(): void {
    this._isActiveComponent = true;
    this.subscribeToStates();
    this.fetchData();
    // console.log("Test test:", this.progressIndicator.hasActiveProgress);
  }

  ngOnDestroy(): void {
    this._isActiveComponent = false;
    this.unSubscribeFromStates();
    this.resetDataFlags();
  }

  // ===================== Subscription Management =====================

  private subscribeToStates(): void {
    if (this.bizEntityStateStoreService.changed) {
      this.bizEntityStoreSubscription = this.bizEntityStateStoreService.changed.pipe(this.skipDuringHierarchyMove).subscribe(() => {
        try {
          this.dataLoadedOnce = {
            deliverables: false,
            objectives: false,
            measures: false
          };
          this.fetchData(true);

          const currentSelectedItem = this.explorerContentAttributes.currentSelectedItem;
          if (currentSelectedItem) {
            this.updateListDataWithoutNavigation(currentSelectedItem);
          }
          this.ensureDeliverablesLoaded();
          this.ensureObjectivesLoaded();
          this.ensureMeasuresLoaded();
        } catch (error) {
          console.error('Error in bizEntity state subscription:', error);
        }
      });
    }
    
    if (this.deliverableStateStoreService.changed) {
      this.deliverableStoreSubscription = this.deliverableStateStoreService.changed.pipe(this.skipDuringHierarchyMove).subscribe(() => {
        try {
          this.dataLoadedOnce.deliverables = false;
          this.fetchData(true);
        } catch (error) {
          console.error('Error in deliverable state subscription:', error);
        }
      });
    }
    
    if (this.objectiveStateStoreService.changed) {
      this.objectiveStoreSubscription = this.objectiveStateStoreService.changed.pipe(this.skipDuringHierarchyMove).subscribe(() => {
        try {
          this.dataLoadedOnce.objectives = false;
          this.fetchData(true);
        } catch (error) {
          console.error('Error in objective state subscription:', error);
        }
      });
    }
    
    if (this.bizEntityTypesStateStoresService.changed) {
      this.bizEntityTypeSubscription = this.bizEntityTypesStateStoresService.changed.subscribe(() => {
        try {
          this.fetchData(true);
        } catch (error) {
          console.error('Error in bizEntityTypes state subscription:', error);
        }
      });
    }
    
    if (this.measureLogStateStoreService.changed) {
      this.measureLogStoreSubscription = this.measureLogStateStoreService.changed.subscribe(() => {
        try {
          this.dataLoadedOnce = {
            deliverables: false,
            objectives: false,
            measures: false,
          };
          this.silentlyRefreshHierarchyStatuses();
        } catch (error) {
          console.error('Error in measureLog state subscription:', error);
        }
      });
    }
    
    if (this.relationshipStateStoreService.changed) {
      this.relationshipStoreSubscription = this.relationshipStateStoreService.changed.subscribe(() => {
        try {
          if (this.appTagService.currentVersion() > this.appTagService.savedVersion()) {
            return;
          }

          // Reset all dataLoadedOnce flags so all data is fetched fresh from APIs
          // since relationships can link any entity to any other entity
          this.dataLoadedOnce = {
            deliverables: false,
            objectives: false,
            measures: false
          };
          this.fetchData(true);
          this.ensureDeliverablesLoaded();
          this.ensureObjectivesLoaded();
          this.ensureMeasuresLoaded();
        } catch (error) {
          console.error('Error in relationship state subscription:', error);
        }
      });
    }

    if (!this.isInModal) {
      this.creationSubscription = strategyEntityCreated$.subscribe(entity => {
        if (this._isActiveComponent && !isExcludedFromStrategyExplorer(entity.type.category)) {
          this.creationSelectionIds.add(String(entity.id));
          void this.refreshCreatedEntity(entity);
        }
      });
    }

    this.incomingSelectionSubscription = this.appStateService.incomingBizEntitySelectionId$.subscribe((id) => {
      if (isStrategyCreationCompletion() && id && this.creationSelectionIds.has(String(id))) return;
      this.creationSelectionIds.clear();
      if (!id || !this._isActiveComponent) {
        return;
      }
      if (this.explorerReveal.handle(id)) {
        return;
      }
      const element = this.explorerAttributes.data.find(item => item.id.toString() === id.toString());
      if (element) {
        this.appStateService.incomingBizEntitySelectionId = '';
        this.updateListData(element.id);
      }
    });

    this.deleteCompletedSubscription = this.contextMenuService.deleteCompletedEvent.subscribe((entity) => {
      this.removeDeletedEntityFromExplorer(entity);
    });
  }

  private unSubscribeFromStates(): void {
    this.creationSubscription?.unsubscribe();
    if (this.bizEntityStoreSubscription) {
      this.bizEntityStoreSubscription.unsubscribe();
    }
    if (this.deliverableStoreSubscription) {
      this.deliverableStoreSubscription.unsubscribe();
    }
    if (this.objectiveStoreSubscription) {
      this.objectiveStoreSubscription.unsubscribe();
    }
    if (this.bizEntityTypeSubscription) {
      this.bizEntityTypeSubscription.unsubscribe();
    }
    if (this.measureLogStoreSubscription) {
      this.measureLogStoreSubscription.unsubscribe();
    }
    if (this.relationshipStoreSubscription) {
      this.relationshipStoreSubscription.unsubscribe();
    }
    if (this.incomingSelectionSubscription) {
      this.incomingSelectionSubscription.unsubscribe();
    }
    if (this.deleteCompletedSubscription) {
      this.deleteCompletedSubscription.unsubscribe();
    }
  }

  private resetDataFlags(): void {
    this.allDataLoaded = false;
    this.dataLoadingFlags = {
      bizEntities: false,
      deliverables: false,
      objectives: false,
      measures: false
    };
    this.dataLoadedOnce = {
      deliverables: false,
      objectives: false,
      measures: false
    };
    this.deletedEntityIds.clear();
  }

  // ===================== Data Loading & State Management =====================
  isLoading = signal<boolean>(false);
  loadingNavigationItemId = signal('');
  private navigationLoadSequence = 0;
  private readonly pendingNavigationLoads = signal<ReadonlyMap<string, number>>(new Map());
  readonly loadingNavigationItemIds = computed(() => [...this.pendingNavigationLoads().keys()]);
  fetchData(isStateStoreServiceStateChanged = false){
    // Only reset bizEntities flag, not all flags
    this.dataLoadingFlags.bizEntities = false;
    this.allDataLoaded = false;
    
    // Always fetch biz entities as they're the core data
    this.fetchBizEntityExplorerData(isStateStoreServiceStateChanged);
  }

  async fetchBizEntityExplorerData(isStateStoreServiceStateChanged = false){
    this.isLoading.set(true);
    try {
      // Root nodes drive the whole nav tree, so they must all be loaded up-front (there's no
      // scroll-triggered UI to request "more root nodes" the way there is for a folder's children).
      const page = await this.loadAllRootEntities([BizEntityTypeCategory.ApplicationRootNode]);
      if(page.items.length > 0){
        // Merge fresh roots into the existing cache instead of replacing it outright, so
        // previously-loaded/expanded children (from earlier pagination requests) survive a
        // background refresh — e.g. one triggered by creating a new entity anywhere in the tree.
        this.appendCachedChildren(page.items);

        if(this.isInModal){

          //this.strategyBenBizEntityData = this.strategyBenBizEntityData.filter(entity => entity.type.category !== BizEntityTypeCategory.Transactional && entity.type.category !== BizEntityTypeCategory.BenzaitenDeliverable );
             //         console.log("Filtered Data:",this.strategyBenBizEntityData)
        }
      }
      this.dataLoadingFlags.bizEntities = true;

      // After bizEntities loaded, set other flags to true if already loaded
      if (this.dataLoadedOnce.deliverables) {
        this.dataLoadingFlags.deliverables = true;
      }
      if (this.dataLoadedOnce.objectives) {
        this.dataLoadingFlags.objectives = true;
      }
      if (this.dataLoadedOnce.measures) {
        this.dataLoadingFlags.measures = true;
      }

      this.checkAndSetupExplorer(isStateStoreServiceStateChanged);
    } catch (error) {
      console.error('Error fetching biz entities:', error);
      this.dataLoadingFlags.bizEntities = true;
      this.checkAndSetupExplorer(isStateStoreServiceStateChanged);
      this.isLoading.set(false);
    }
  }

  /**
   * Loads every root-level entity across as many backend pages as needed, since the nav tree
   * needs the complete top-level list (unlike content-pane children, which page in via scroll).
   */
  private async loadAllRootEntities(categoryTypes: BizEntityTypeCategory[]): Promise<Page<IBizEntity>> {
    const bufferKey = '';
    let allItems: IBizEntity[] = [];
    let totalCount = 0;
    const MAX_ROOT_PAGES = 50; // safety guard against a runaway loop if the backend misbehaves
    for (let i = 0; i < MAX_ROOT_PAGES; i++) {
      const page = await this.fetchStrategyEntityPage(undefined, this.contentItemCountPerPage, allItems.length, categoryTypes);
      if (page.items.length === 0) {
        break;
      }
      allItems = allItems.concat(page.items);
      totalCount = page.totalCount;
      if (allItems.length >= totalCount) {
        break;
      }
    }

    const result: Page<IBizEntity> = { items: allItems, totalCount: allItems.length };
    this.paginationBuffer.setInitialPage(bufferKey, result);
    return result;
  }

  /**
   * Lazy load deliverables only when needed
   * Call this before accessing deliverables data
   */
  private ensureDeliverablesLoaded(ids?: string[]): Promise<void> {
    if (this.dataLoadedOnce.deliverables && !ids?.length) {
      return Promise.resolve();
    }
    
    return this.deliverableStateStoreService.getState(
      this.bizEntityTypesStateStoresService, 
      this.benBizEntityProgressStatusStoreService, 
      this.kpiStateStoreService, 
      this.measuresStateStoreService,
      ids
    )
      .then((data) => {
        if (data) {
          const deliverablesById = new Map(this.deliverables.map((deliverable) => [deliverable.id, deliverable]));
          data.forEach((deliverable) => deliverablesById.set(deliverable.id, deliverable));
          this.deliverables = Array.from(deliverablesById.values());
        }
        this.dataLoadedOnce.deliverables = !ids?.length;
        this.dataLoadingFlags.deliverables = true;
      })
      .catch((error) => {
        console.error('Error fetching deliverables:', error);
        this.dataLoadingFlags.deliverables = true;
      });
  }

  /**
   * Lazy load objectives only when needed
   * Call this before accessing objectives data
   */
  private ensureObjectivesLoaded(ids?: string[]): Promise<void> {
    if (this.dataLoadedOnce.objectives && !ids?.length) {
      return Promise.resolve();
    }
    const loadedIds = new Set(this.objectives.map((objective) => objective.id.toString()));
    const idsToLoad = ids?.filter((id) => !loadedIds.has(id.toString()));
    if (ids?.length && idsToLoad?.length === 0) {
      return Promise.resolve();
    }
    
    return this.objectiveStateStoreService.getState(this.bizEntityTypesStateStoresService, idsToLoad)
      .then((data) => {
        if (data) {
          const objectivesById = new Map(this.objectives.map((objective) => [objective.id, objective]));
          data.forEach((objective) => objectivesById.set(objective.id, objective));
          this.objectives = Array.from(objectivesById.values());
        }
        this.dataLoadedOnce.objectives = !ids?.length;
        this.dataLoadingFlags.objectives = true;
      })
      .catch((error) => {
        // console.error('Error fetching objectives:', error);
        this.dataLoadingFlags.objectives = true;
      });
  }
  
  /**
   * Lazy load measures only when needed
   * Call this before accessing measures data
   */
  private ensureMeasuresLoaded(ids?: string[]): Promise<void> {
    if (this.dataLoadedOnce.measures && !ids?.length) {
      return Promise.resolve();
    }
    const loadedIds = new Set(this.measureData.map((measure) => measure.id.toString()));
    const idsToLoad = ids?.filter((id) => !loadedIds.has(id.toString()));
    if (ids?.length && idsToLoad?.length === 0) {
      return Promise.resolve();
    }
    
    return this.measuresStateStoreService.getState(this.bizEntityTypesStateStoresService, idsToLoad)
      .then((data) => {
        if (data) {
          const measuresById = new Map(this.measureData.map((measure) => [measure.id, measure]));
          data.forEach((measure) => measuresById.set(measure.id, measure));
          this.measureData = Array.from(measuresById.values());
        }
        this.dataLoadedOnce.measures = !ids?.length;
        this.dataLoadingFlags.measures = true;
      })
      .catch((error) => {
        console.error('Error fetching measures:', error);
        this.dataLoadingFlags.measures = true;
      });
  }

  fetchDeliverablesData(isStateStoreServiceStateChanged = false){
        // Fetch deliverables
    this.deliverableStateStoreService.getState( this.bizEntityTypesStateStoresService, this.benBizEntityProgressStatusStoreService, this.kpiStateStoreService, this.measuresStateStoreService)
      .then((data) => {
        if(data){
          this.deliverables = data;
        }
        this.dataLoadingFlags.deliverables = true;
        this.checkAndSetupExplorer(isStateStoreServiceStateChanged);
      })
      .catch((error) => {
        console.error('Error fetching deliverables:', error);
        this.dataLoadingFlags.deliverables = true;
        this.checkAndSetupExplorer(isStateStoreServiceStateChanged);
      });

  }

  fetchObjectivesData(isStateStoreServiceStateChanged = false){
     this.objectiveStateStoreService.getState( this.bizEntityTypesStateStoresService)
      .then((data) => {
        if(data){
          this.objectives = data;
        }
        this.dataLoadingFlags.objectives = true;
        this.checkAndSetupExplorer(isStateStoreServiceStateChanged);
      })
      .catch((error) => {
        console.error('Error fetching objectives:', error);
        this.dataLoadingFlags.objectives = true;
        this.checkAndSetupExplorer(isStateStoreServiceStateChanged);
      });
  }
  
  fetchMeasuresData(isStateStoreServiceStateChanged = false){
    this.measuresStateStoreService.getState(this.bizEntityTypesStateStoresService)
      .then((data) => {
        if(data){
          this.measureData = data;
        }
        this.dataLoadingFlags.measures = true;
        this.checkAndSetupExplorer(isStateStoreServiceStateChanged);
      })
      .catch((error) => {
        console.error('Error fetching measures:', error);
        this.dataLoadingFlags.measures = true;
        this.checkAndSetupExplorer(isStateStoreServiceStateChanged);
      });
  }

  /**
   * Check if all data is loaded and setup explorer only once
   * This prevents redundant setupExplorerOnInit calls and improves performance
   */
  private checkAndSetupExplorer(isStateStoreServiceStateChanged: boolean): void {
    const allLoaded = this.dataLoadingFlags.bizEntities && 
                      this.dataLoadingFlags.deliverables && 
                      this.dataLoadingFlags.objectives && 
                      this.dataLoadingFlags.measures;
    
    if (allLoaded && !this.allDataLoaded) {
      this.allDataLoaded = true;
      
      Promise.resolve(this.setupExplorerOnInit(isStateStoreServiceStateChanged))
        .finally(() => this.isLoading.set(false));
    } else if (this.dataLoadingFlags.bizEntities && !this.allDataLoaded) {
      // If only bizEntities are loaded, setup explorer with available data
      this.allDataLoaded = true;
      Promise.resolve(this.setupExplorerOnInit(isStateStoreServiceStateChanged))
        .finally(() => this.isLoading.set(false));
    }
  }

  /**
   * Re-fetches biz entities with fresh rollup status and silently updates the hierarchy
   * nav and content list — without changing dataRefreshedToken, so there is no
   * full Explorer re-render or visible loading/bounce effect.
   */
  private silentlyRefreshHierarchyStatuses(): void {
    const loadedEntityIds = this.strategyBenBizEntityData.map((entity) => entity.id);
    if (loadedEntityIds.length === 0) {
      return;
    }

    this.bizEntityStateStoreService.getState(
      this.bizEntityTypesStateStoresService,
      this.bizEntityChildrenStatusStoreService,
      loadedEntityIds
    ).then((data) => {
      if (!data) return;

      this.bizEntities = data;
      this.strategyBenBizEntityData = filterBizEntitiesForStrategyExplorer(data)
        .sort(this.sortDataKeepingRootAtTop);
      this.explorerAttributes.data = this.strategyBenBizEntityData as any;
      this.explorerNavAttributes.data = [...this.strategyBenBizEntityData];
      if (!this.explorerNavAttributes.data.some(item => item.parentId === '')) {
        const temp = [...this.utilService.findAncestors(
          this.explorerNavAttributes.data as any,
          this.strategyBenBizEntityData
        )];
        this.explorerNavAttributes.data = temp as any[];
      }

      const currentItemId = this.explorerNavAttributes.currentSelectedItem ||
                            this.explorerContentAttributes.currentSelectedItem;
      if (currentItemId) {
        this.updateListDataWithoutNavigation(currentItemId);
      } else {
        refreshExplorerNav(this.explorerComponent);
      }
    }).catch((error) => {
      console.error('Error silently refreshing hierarchy statuses:', error);
    });
  }

  setupExplorerOnInit(isStateStoreServiceStateChanged = false): Promise<void> {
    this.populateStrategyBenBizEntityData();
    const definePromise = this.defineExplorerAttributes(isStateStoreServiceStateChanged);
    this.getContextMenuItem();
    return definePromise;
  }

  // ===================== Data Preparation =====================

  private populateStrategyBenBizEntityData(): void {
    // this.strategyBenBizEntityData = this.utilService.findAncestors(this.strategyBenBizEntityData as IBizEntity[], this.bizEntities);
    this.strategyBenBizEntityData = this.populateEachChildWithData(this.strategyBenBizEntityData);
  }

  private populateEachChildWithData(childArray: IBizEntity[]): IBizEntity[] {
    if (!Array.isArray(childArray)) {
      console.error('Invalid child array.');
      return [];
    }
    return childArray.map((child: IBizEntity) => ({
      ...child,
      ...this.enrichBizEntityWithDetails(child)
    }));
  }

  private enrichBizEntityWithDetails(hierarchy: IBizEntity): IBizEntity {
    if (!hierarchy || !hierarchy.id) {
      console.error('Invalid hierarchy data.');
      return hierarchy;
    }
    return { ...hierarchy };    
  }

  private extractItemChildren(itemId: string): IBizEntity[] {
    const item = this.utilService.extractItemChildren(itemId, this.strategyBenBizEntityData);
    return item as IBizEntity[];
  }

  private findDisplayedEntity(itemId: string): IBizEntity | undefined {
    // Prefer the enriched records (.kpis/.progressStatus from ensureDeliverablesLoaded/
    // fetchDeliverablesData, .kpis from ensureObjectivesLoaded's equivalent) over the generic
    // structural entity - the latter is never patched with these fields (see
    // populateEachChildWithData/enrichBizEntityWithDetails, which just spreads the hierarchy node),
    // so opening a Deliverable's detail view from either a row click or the context menu would
    // otherwise show no linked Progress KPI.
    const enriched = this.deliverables.find(entity => entity.id.toString() === itemId.toString())
      ?? this.objectives.find(entity => entity.id.toString() === itemId.toString());
    if (enriched) {
      return enriched;
    }

    const contentEntity = this.explorerContentAttributes.data?.find(
      entity => entity.id.toString() === itemId.toString()
    );
    if (contentEntity) {
      return contentEntity;
    }

    return this.explorerAttributes.data?.find(
      entity => entity.id.toString() === itemId.toString()
    ) ?? this.strategyBenBizEntityData.find(
      entity => entity.id.toString() === itemId.toString()
    );
  }

  private appendCachedChildren(appendedChildren: IBizEntity[]): void {
    const visibleChildren = appendedChildren.filter(
      entity => !this.deletedEntityIds.has(entity.id.toString())
    );
    if (visibleChildren.length === 0) {
      return;
    }

    const entitiesById = new Map(this.bizEntities.map((entity) => [String(entity.id), entity]));
    for (const entity of visibleChildren) {
      entitiesById.set(String(entity.id), entity);
    }
    this.bizEntities = Array.from(entitiesById.values());

    // Derive from the id-keyed map (Map.set on an existing key preserves its original
    // insertion position) instead of filtering out touched rows and re-appending them,
    // so a refresh that re-touches already-loaded rows doesn't reshuffle their order.
    this.strategyBenBizEntityData = filterBizEntitiesForStrategyExplorer(this.bizEntities)
      .sort(this.sortDataKeepingRootAtTop);
    this.explorerAttributes.data = this.strategyBenBizEntityData as any;
    this.explorerNavAttributes.data = [...this.strategyBenBizEntityData];
    refreshExplorerNav(this.explorerComponent);
  }

  /**
   * Reconciles a persisted creation without navigating away from the current folder.
   * @param entity - Snapshot containing the server ID and submitted parent.
   * @returns Completion of the affected parent's refresh, if it is currently viewed.
   * @example await this.refreshCreatedEntity(createdEntity);
   */
  private refreshCreatedEntity(entity: IBizEntity): Promise<void> {
    return refreshCreatedExplorerEntity({
      entity,
      attributes: this.explorerAttributes,
      explorer: this.explorerComponent,
      buffer: this.paginationBuffer,
      isActive: () => this._isActiveComponent,
      append: entities => this.appendCachedChildren(entities),
      loadAncestors: () => this.bizEntityStateStoreService.getState(
        this.bizEntityTypesStateStoresService,
        this.bizEntityChildrenStatusStoreService,
        undefined, undefined, entity.parentId?.toString()
      ).then(entities => entities ?? []),
      invalidate: parentId => {
        this.rawOffsetByParent.delete(parentId);
        if (this.explorerContentAttributes.currentSelectedItem === parentId) {
          ++this.contentRequestSequence;
        }
      },
      refreshContent: (parentId, loadedCount) => this.defineExplorerContentAttributes(parentId, true, loadedCount),
      onError: error => {
        console.error('Failed to refresh the created entity in Strategy Explorer:', error);
        this.toastService.toast('The item was saved, but its view could not be refreshed. Reopen its parent to retry.');
      },
    });
  }

  /** Records a definitive empty-page result so the nav can remove that folder's expand affordance. */
  private updateKnownEmptyFolder(itemId: string, isEmpty: boolean): void {
    const knownEmptyFolderIds = this.explorerNavAttributes.knownEmptyFolderIds ?? [];
    const wasKnownEmpty = knownEmptyFolderIds.includes(itemId);
    if (wasKnownEmpty === isEmpty) {
      return;
    }

    this.explorerNavAttributes.knownEmptyFolderIds = isEmpty
      ? [...knownEmptyFolderIds, itemId]
      : knownEmptyFolderIds.filter(id => id !== itemId);
    refreshExplorerNav(this.explorerComponent);
  }

  /** Immediately removes a successfully deleted entity from the visible and paginated explorer state. */
  private removeDeletedEntityFromExplorer(entity: IBizEntity): void {
    const deletedId = entity.id.toString();
    this.deletedEntityIds.add(deletedId);

    const withoutDeletedEntity = <T extends IBizEntity>(items: T[]): T[] =>
      items.filter(item => item.id.toString() !== deletedId);
    this.bizEntities = withoutDeletedEntity(this.bizEntities);
    this.strategyBenBizEntityData = withoutDeletedEntity(this.strategyBenBizEntityData);
    this.deliverables = withoutDeletedEntity(this.deliverables);
    this.objectives = withoutDeletedEntity(this.objectives);
    this.measureData = withoutDeletedEntity(this.measureData);
    this.explorerAttributes.data = withoutDeletedEntity(this.explorerAttributes.data);
    this.explorerNavAttributes.data = withoutDeletedEntity(this.explorerNavAttributes.data);
    this.removeContentRow(deletedId);

    const parentId = entity.parentId?.toString() ?? '';
    const parentItems = this.paginationBuffer.getItems(parentId);
    const wasInParentBuffer = parentItems.some(item => item.id.toString() === deletedId);
    if (wasInParentBuffer) {
      const totalCount = this.paginationBuffer.getTotalCount(parentId) ?? parentItems.length;
      this.paginationBuffer.setInitialPage(parentId, {
        items: withoutDeletedEntity(parentItems),
        totalCount: Math.max(0, totalCount - 1),
      });
      const rawOffset = this.rawOffsetByParent.get(parentId);
      if (rawOffset !== undefined) {
        this.rawOffsetByParent.set(parentId, Math.max(0, rawOffset - 1));
      }
    }

    refreshExplorerNav(this.explorerComponent);
    this.explorerComponent?.interceptListActions(this.explorerContentAttributes.listData);
  }

  private removeContentRow(id: string): void {
    this.explorerContentAttributes.data = this.explorerContentAttributes.data.filter(item => item.id.toString() !== id);
    this.explorerContentAttributes.listData = {
      ...this.explorerContentAttributes.listData,
      items: this.explorerContentAttributes.listData.items.filter(item => String(item.id) !== id),
    };
  }

  private sortDataKeepingRootAtTop(a: IBizEntity, b: IBizEntity): number {
    const parentIdA = a.parentId || '';
    const parentIdB = b.parentId || '';
  
    if (parentIdA === '' && parentIdB !== '') {
      return -1;
    }
    if (parentIdA !== '' && parentIdB === '') {
      return 1;
    }
    return 0;
  }

  // ===================== Sub-Header Management =====================

  private defineSubHeaderAttributes(): Promise<void> {
    return this.prepareAddButtonOptions()
      .then(() => {
        if (this.isInModal) {
          this.subHeaderAttributes.add = false;
          this.subHeaderAttributes.addWithOptions = false;
          this.subHeaderAttributes.filter = false;
          this.subHeaderAttributes.graphView = false;
        }
        this.subHeaderAttributes.addButtonOptions = this.subHeaderOptions;
      });
  }

  private prepareAddButtonOptions(): Promise<void> {
    const options: IAddButtonOptions[] = [];
    
    return this.bizEntityTypesStateStoresService.getState()
      .then((data) => {
        if (data) {
          this.bizEntityTypes = data.filter(item => 
            !item.isSystemBasic && 
            item.category !== BizEntityTypeCategory.Tenant && 
            item.category !== BizEntityTypeCategory.BenzaitenKPIAutoStore && 
            item.category !== BizEntityTypeCategory.BenzaitenMeasureAutoStore
          );
        } else {
          this.bizEntityTypes = [];
        }

        if (!Array.isArray(this.bizEntityTypes)) {
          console.error('Invalid business entity types.');
          this.subHeaderOptions = options;
          return;
        }
        
        this.bizEntityTypes = filterBizEntityTypesForStrategyExplorer(
          this.bizEntityTypes.filter(item => item.isSystemType === true)
        );
        
        this.bizEntityTypes.forEach((type) => {
          options.push({ id: type.id, label: type.name, icon: type.icon || 'cil-plus' });
        });
        
        this.subHeaderOptions = options;
      })
      .catch((error) => {
        console.error('Error preparing add button options:', error);
        this.subHeaderOptions = options;
      });
  }

  onAddButtonOptionClick = (option: IAddButtonOptions): void => {
    this.appStateService.selectedBizEntityForEdit = null;
    
    if (this.appStateService.entityFormState !== FormStates.Idle) {
      console.error("Entity form state is not idle. Cannot proceed with new entity creation.");
      return;
    }

    const entityType = this.bizEntityTypes.find(item => item.id === option.id);
    if (!entityType) {
      console.error("Invalid entity type.");
      return;
    }

    this.appStateService.selectedBizEntityTypeForNewBizEntity = entityType;

    const offCanvasComponent = getOffCanvasComponentForBizEntityCategory(entityType);
    if (offCanvasComponent !== null) {
      this.appStateService.entityFormState = FormStates.New;
      this.openBizEntityFormInOffCanvas();
    } else {
      console.error("No off-canvas component found for the selected biz entity type.");
    }
  }

  // ===================== Explorer Configuration =====================
  private async defineExplorerAttributes(isStateStoreServiceStateChanged = false,data: IBizEntity[] = this.strategyBenBizEntityData): Promise<void> {
    this.explorerAttributes.data = data as any
    this.explorerAttributes.isInModal = this.isInModal;
    this.explorerAttributes.subHeaderAttributes = this.subHeaderAttributes;
    this.explorerAttributes.explorerNavAttributes = this.explorerNavAttributes;
    this.explorerAttributes.explorerContentAttributes = this.explorerContentAttributes;
    // this.explorerAttributes.explorerGridAttributes = this.explorerContentGridAttributes;
    // this.explorerAttributes.explorerContentGraphAttributes = this.explorerGraphAttributes;
    this.explorerAttributes.explorerContentGraphAttributes = this.explorerContentGraphAttributes;

    this.defineSubHeaderAttributes();
    this.defineExplorerNavAttributes();
    this.defineExplorerContentGraphAttributes();
    // Determine target selection based on context
    let targetItemId: string;
    let contentItemId: string | undefined;
    let shouldUpdatePreSelectedItem = false;
    
    if (isStateStoreServiceStateChanged) {
      // During state updates, preserve current selection to avoid jumping
      // Prioritize nav selection (the parent being viewed) over content selection (child item)
      const currentSelection = this.explorerNavAttributes.currentSelectedItem || 
                               this.explorerContentAttributes.currentSelectedItem;
      const rootElement = this.explorerAttributes.data.find(item => !item.parentId || item.parentId === '');
      targetItemId = currentSelection || rootElement?.id || '';
      // Nothing selected yet (e.g. a store refresh raced the initial load) - select the root.
      shouldUpdatePreSelectedItem = !currentSelection && !!targetItemId;
      
      // Redirect to newly created BizEntity if incomingBizEntitySelectionId is set
      // Note: Transaction log creation does not set this, so it won't trigger a redirect
      if(this.appStateService.incomingBizEntitySelectionId &&
        !this.creationSelectionIds.has(String(this.appStateService.incomingBizEntitySelectionId)) &&
        this.appStateService.incomingBizEntitySelectionId !== currentSelection){
        let newEntityId = this.appStateService.incomingBizEntitySelectionId;
        let element = this.explorerAttributes.data.find(item => item.id.toString() === newEntityId.toString());
        if(element){
          targetItemId = element.id || '';
          // Only update preSelectedItem when redirecting to a newly created entity
          shouldUpdatePreSelectedItem = true;
          // Clear the incoming selection only after successfully finding and consuming it
          // This prevents losing the id if data hasn't been refreshed yet (e.g., deliverable creation through relationship store)
          this.appStateService.incomingBizEntitySelectionId = '';
        }
      }

    } else {
      // On initial load, use incoming selection or root element
      const preSelectedItemId = this.appStateService.incomingBizEntitySelectionId;
      consumeExplorerReveal(ExplorerRoutes.Strategy, preSelectedItemId);
      // If navigating in from elsewhere (e.g. a pinned Dashboard card double-click) the
      // target entity may not be in the root-only cache yet - fetch it and its ancestors so
      // the Explorer library can resolve its parent and select it there.
      const preSelectedEntity = preSelectedItemId ? await this.explorerReveal.load(preSelectedItemId) : undefined;
      const rootElement = this.explorerAttributes.data.find(item => !item.parentId || item.parentId === '');
      targetItemId = (preSelectedItemId && this.explorerAttributes.data.length > 0) 
        ? preSelectedItemId 
        : (rootElement?.id || '');
      // The library selects the entity inside its parent, so open the parent (paged until the entity is present).
      contentItemId = preSelectedEntity && this.explorerReveal.track(preSelectedEntity);
      // Always update preSelectedItem on initial load
      shouldUpdatePreSelectedItem = true;
    }
    
    // this.defineExplorerContentGridAttributes();
    // this.defineExplorerContentGraphAttributes();
    
    // Load data for the selected item
    let contentLoad: Promise<void> = Promise.resolve();
    if (isStateStoreServiceStateChanged && targetItemId) {
      if (shouldUpdatePreSelectedItem) {
        // Redirecting to newly created entity - use full navigation update
        this.updateListData(targetItemId);
      } else {
        // Regular state change (e.g., new entity/transaction log creation) - refresh content
        // without navigation change, so newly created children of the current view appear
        this.updateListDataWithoutNavigation(targetItemId);
      }
    } else if (targetItemId) {
      // On initial load, populate content with selected element
      contentLoad = Promise.resolve(this.updateListData(contentItemId ?? targetItemId));
    }

    // Set preselected item for UI only on initial load or when redirecting to newly created entity
    // Skip this during state changes (e.g., transaction log creation) to preserve current navigation
    if (targetItemId && shouldUpdatePreSelectedItem) {
      this.explorerAttributes.preSelectedItemId = targetItemId;
      this.explorerAttributes.explorerNavAttributes.currentSelectedItem = contentItemId ?? targetItemId;
    } else if (isStateStoreServiceStateChanged && !shouldUpdatePreSelectedItem) {
      // Clear preSelectedItemId during state changes to remove highlighter when not redirecting
      this.explorerAttributes.preSelectedItemId = '';
    }

    // Creation notifications never set incoming selection. Preserve full library
    // navigation only for initial/explicit selection, with the hint already assigned.
    if (!isStateStoreServiceStateChanged || shouldUpdatePreSelectedItem) {
      refreshExplorer(this);
    } else {
      refreshExplorerNav(this.explorerComponent);
    }

    // Keep the loader up until the root's children are rendered, instead of showing a blank list.
    await contentLoad.catch(error => console.error('Error loading initial explorer content:', error));
  }
  
  getContextMenuItem(): void {
    this.contextMenuItems = this.contextMenuService.getMenu();
    this.explorerAttributes.contextMenuItems = this.contextMenuItems;
  }

  // ===================== Explorer Navigation =====================

  private defineExplorerNavAttributes(): void {
    this.explorerNavAttributes.data = [...this.explorerAttributes.data];
    if (!this.explorerNavAttributes.data.some(item => item.parentId === '')) {
      const temp = [...this.utilService.findAncestors(this.explorerNavAttributes.data as any, this.strategyBenBizEntityData)];
      this.explorerNavAttributes.data = temp as any[];
    }
  }

  private async trackNavigationLoad<T>(itemId: string, load: () => Promise<T>): Promise<T> {
    const key = itemId.toString();
    this.pendingNavigationLoads.update(counts => {
      const next = new Map(counts);
      next.set(key, (next.get(key) ?? 0) + 1);
      return next;
    });
    try {
      return await load();
    } finally {
      this.pendingNavigationLoads.update(counts => {
        const next = new Map(counts);
        const remaining = (next.get(key) ?? 1) - 1;
        if (remaining > 0) {
          next.set(key, remaining);
        } else {
          next.delete(key);
        }
        return next;
      });
    }
  }

  navItemClicked = (itemId: string) => {
    const navigationLoadSequence = ++this.navigationLoadSequence;
    // Keep the Explorer's fallback row loader aligned with the clicked row before
    // setting isLoading; otherwise the previously selected root can show a spinner.
    this.explorerNavAttributes.currentSelectedItem = itemId;
    this.explorerContentAttributes.currentSelectedItem = itemId;
    this.isLoading.set(true);
    this.loadingNavigationItemId.set(itemId);
    this.explorerNavAttributes.isLoading = false;
    
    this.lastVisitedItemId = itemId;
    this.explorerContentAttributes.currentSelectedItem = itemId;
    this.subHeaderAttributes.previouseDisable = false;
     if (this.isInModal) {
      this._selectedEntity = this.strategyBenBizEntityData.find(entity => String(entity.id) === String(itemId)) ?? null;
    }
    this.trackNavigationLoad(itemId, () => this.updateListData(itemId))
      .catch((error) => {
        console.error('Error updating list data:', error);
      })
      .finally(() => {
        if (navigationLoadSequence === this.navigationLoadSequence) {
          this.isLoading.set(false);
          this.loadingNavigationItemId.set('');
          this.explorerNavAttributes.isLoading = false;
        }
      });
    this.resetIncomingBizEntitySelectionId();
  }

  async onHierarchyChange(event: IHierarchyItem): Promise<void> {
    if (this.hierarchyMoveUncertain) {
      this.toastService.toast('Reload to confirm the previous move before moving more items.');
      return;
    }
    if (this.hierarchyMoveBusy) return;
    this.hierarchyMoveBusy = true;
    const entity = this.findLoadedEntity(event.id.toString());
    if (entity) this.hierarchyOriginalParents.set(entity, entity.parentId);
    try {
      await this.hierarchyMoveHandler.handleMove(event);
    } finally {
      this.hierarchyMoveBusy = false;
    }
  }

  private findLoadedEntity(id: string): IBizEntity | undefined {
    return this.strategyBenBizEntityData.find(entity => entity.id.toString() === id)
      ?? this.bizEntities.find(entity => entity.id.toString() === id);
  }

  /** Saves the new parent through the entity's typed store (IDeliverable, IObjective, ...). */
  private async persistHierarchyMove(move: IHierarchyMove): Promise<void> {
    const entity = await this.loadHierarchyRecord(move);
    this.hierarchyReadParents.set(move, entity.parentId);
    const payload = createHierarchyMovePayload(move, entity);
    this.hierarchyWritesAttempted.add(move);
    await this.stateStoreUtilsService.updateBizEntityInRelevantStateStores(payload);
  }

  private refreshHierarchyAfterMove(move: IHierarchyMove): Promise<void> {
    const affectedParentIds = new Set([move.previousParentKey, move.nextParentKey]);
    const loadedCounts = new Map<string, number>();

    for (const parentId of affectedParentIds) {
      loadedCounts.set(parentId, this.paginationBuffer.getItems(parentId).length);
      this.paginationBuffer.clear(parentId);
      this.rawOffsetByParent.delete(parentId);
    }

    for (const entities of [this.bizEntities, this.strategyBenBizEntityData, this.deliverables,
      this.objectives, this.measureData, this.explorerContentAttributes.data]) {
      for (const entity of entities) {
        if (entity.id.toString() === move.entityId) entity.parentId = move.nextParentId;
      }
    }
    // A cleared pagination buffer is unknown, not proof that its parent is empty.
    this.explorerNavAttributes.knownEmptyFolderIds = this.explorerNavAttributes.knownEmptyFolderIds
      ?.filter(id => !affectedParentIds.has(id));
    this.appendCachedChildren([move.entity]);

    const selectedParentId = this.explorerContentAttributes.currentSelectedItem?.toString() ?? '';
    if (selectedParentId === move.previousParentKey && move.nextParentKey !== move.previousParentKey) {
      // Drop the moved row right away; the refetch below reconciles the rest.
      this.removeContentRow(move.entityId);
      this.explorerComponent?.interceptListActions(this.explorerContentAttributes.listData);
    }
    if (affectedParentIds.has(selectedParentId)) {
      const loadedCount = loadedCounts.get(selectedParentId) ?? this.contentItemCountPerPage;
      // Returned so the move handler keeps the shimmer up until the refreshed list is rendered.
      return this.defineExplorerContentAttributes(
        selectedParentId,
        true,
        Math.max(loadedCount, this.contentItemCountPerPage)
      ).catch(error => {
        console.error(`Failed to refresh moved items under parent ${selectedParentId}`, error);
        this.toastService.toast('The item moved, but the list could not be refreshed.');
      });
    }
    return Promise.resolve();
  }

  /**
   * Reads the typed store for a hierarchy write/reconciliation, bypassing UI loader caches.
   * @param move - Requested entity and category.
   * @returns A confirmed typed record; remote store mode performs a GET.
   * @throws If the read fails, the record is missing, or its category changed.
   * @example const entity = await this.loadHierarchyRecord(move);
   */
  private async loadHierarchyRecord(move: IHierarchyMove): Promise<IBizEntity> {
    const category = move.entity.type?.category;
    if (!category) throw new Error(`Cannot move entity ${move.entityId} without a category`);
    let entities: IBizEntity[] | undefined;
    switch (category) {
      case BizEntityTypeCategory.BenzaitenDeliverable:
        entities = await this.deliverableStateStoreService.getState(this.bizEntityTypesStateStoresService,
          this.benBizEntityProgressStatusStoreService, this.kpiStateStoreService, this.measuresStateStoreService, [move.entityId]);
        break;
      case BizEntityTypeCategory.BenzaitenKPI:
        entities = await this.kpiStateStoreService.getState(this.bizEntityTypesStateStoresService, this.measuresStateStoreService, [move.entityId]);
        break;
      case BizEntityTypeCategory.BenzaitenMeasure:
        entities = await this.measuresStateStoreService.getState(this.bizEntityTypesStateStoresService, [move.entityId]);
        break;
      case BizEntityTypeCategory.BenzaitenObjective:
        entities = await this.objectiveStateStoreService.getState(this.bizEntityTypesStateStoresService, [move.entityId]);
        break;
      default:
        entities = await this.bizEntityStateStoreService.getState(this.bizEntityTypesStateStoresService, undefined, [move.entityId]);
    }
    return resolveHierarchyRecord(move, entities);
  }

  private ensureTypedDataLoadedForCategory(category: BizEntityTypeCategory, entityId: string): Promise<void> {
    switch (category) {
      case BizEntityTypeCategory.BenzaitenDeliverable:
        return this.ensureDeliverablesLoaded([entityId]);
      case BizEntityTypeCategory.BenzaitenMeasure:
        return this.ensureMeasuresLoaded([entityId]);
      case BizEntityTypeCategory.BenzaitenObjective:
        return this.ensureObjectivesLoaded([entityId]);
      default:
        return Promise.resolve();
    }
  }

  private resolveTypedEntityForHierarchyUpdate(id: string, category: BizEntityTypeCategory): IBizEntity | null {
    switch (category) {
      case BizEntityTypeCategory.BenzaitenDeliverable: {
        const deliverable = this.deliverables.find(d => d.id.toString() === id);
        return deliverable ?? null;
      }
      case BizEntityTypeCategory.BenzaitenMeasure: {
        const measure = this.measureData.find(m => m.id.toString() === id);
        return measure ?? null;
      }
      case BizEntityTypeCategory.BenzaitenObjective: {
        const objective = this.objectives.find(o => o.id.toString() === id);
        return objective ?? null;
      }
      default: {
        const entity = this.strategyBenBizEntityData.find(e => e.id.toString() === id);
        return entity ?? null;
      }
    }
  }
  // ===================== Explorer Content =====================

  updateListData(itemId: string): Promise<void> {
    this.explorerNavAttributes.currentSelectedItem = itemId;
    this.explorerContentAttributes.currentSelectedItem = itemId;
    return this.defineExplorerContentAttributes(itemId);
  }
  
  /**
   * Update list data for current selection without changing navigation state
   * Used during data refreshes to avoid visual jumping
   */
  private updateListDataWithoutNavigation(itemId: string): void {
    // preserveLoadedCount=true: keep whatever page depth the user had already scrolled to,
    // rather than resetting the pagination buffer back down to just the first page.
    this.defineExplorerContentAttributes(itemId, true);
    // Update nav to reflect any data changes without changing selection
    refreshExplorerNav(this.explorerComponent);
  }

  override async onPaginationRequest(request: IPaginationReqMessage): Promise<void> {
    const isNavRequest = request.requesterId.startsWith('explorer-nav-');
    // Keep the nav tree's own loading state isolated from content-pane pagination requests,
    // so scrolling the list doesn't blank the hierarchy with a full-tree skeleton.
    this.explorerNavAttributes.isLoading = isNavRequest;
    try {
      await super.onPaginationRequest(request);
    } finally {
      this.explorerNavAttributes.isLoading = false;
    }
  }

  protected override resolvePaginationParentId(request: IPaginationReqMessage): string {
    return request.parentId || this.explorerContentAttributes.currentSelectedItem || '';
  }

  protected override setPaginationLoading(isLoading: boolean): void {
    this.isLoading.set(isLoading);
  }

  protected override async fetchPaginationPage(
    parentId: string | undefined,
    limit: number,
    offset: number
  ): Promise<Page<IBizEntity>> {
    return this.fetchStrategyEntityPage(parentId, limit, offset);
  }

  private async fetchStrategyEntityPage(
    parentId: string | undefined,
    limit: number,
    offset: number,
    categoryTypes: BizEntityTypeCategory[] = this.getStrategyExplorerCategories()
  ): Promise<Page<IBizEntity>> {
    const bufferKey = parentId || '';
    const generation = this.paginationBuffer.getGeneration(bufferKey);
    // offset === 0 means "start over" (new selection / forced refresh) - reset the raw cursor too,
    // rather than reusing a stale raw offset left over from a previous visit to this parent.
    let rawOffset = offset === 0 ? 0 : (this.rawOffsetByParent.get(bufferKey) ?? offset);

    // The backend's totalRecords counts raw rows before filterBizEntitiesForStrategyExplorer()
    // removes excluded categories, so a single raw page doesn't reliably yield `limit` filtered
    // items. Keep pulling raw pages (bounded by MAX_RAW_FETCHES) until we have enough filtered
    // items or the backend confirms there's nothing left.
    const filteredItems: IBizEntity[] = [];
    let exhausted = false;
    const MAX_RAW_FETCHES = 20;
    for (let i = 0; i < MAX_RAW_FETCHES && filteredItems.length < limit; i++) {
      const data = await this.bizEntityStateStoreService.getState(
        this.bizEntityTypesStateStoresService,
        this.bizEntityChildrenStatusStoreService,
        undefined,
        parentId,
        undefined,
        undefined,
        categoryTypes,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        limit,
        rawOffset
      );
      const rawItems = data ?? [];
      rawOffset += rawItems.length;
      filteredItems.push(...filterBizEntitiesForStrategyExplorer(rawItems).filter(
        entity => !this.deletedEntityIds.has(entity.id.toString())
      ));
      if (rawItems.length < limit) {
        exhausted = true;
        break;
      }
    }

    if (generation === this.paginationBuffer.getGeneration(bufferKey)) {
      this.rawOffsetByParent.set(bufferKey, rawOffset);
    }

    const items = filteredItems.slice(0, limit);
    // We can't know the true filtered total until the raw source is exhausted, so report an
    // exact count once it is, and otherwise a "there's at least one more" lower-bound estimate
    // that keeps the Lister requesting further pages instead of stopping prematurely.
    const totalCount = exhausted ? offset + items.length : offset + items.length + 1;

    return { items, totalCount };
  }

  private getStrategyExplorerCategories(): BizEntityTypeCategory[] {
    return Object.values(BizEntityTypeCategory).filter(
      (category): category is BizEntityTypeCategory =>
        typeof category === 'number' && !isExcludedFromStrategyExplorer(category)
    );
  }

  protected override logPaginationDebug(bufferKey: string, appendedItems: IBizEntity[], totalCount: number, itemCountPerPage: number): void {
    const loadedPages = this.paginationBuffer.getLoadedPageCount(bufferKey, itemCountPerPage);
    const remainingPages = this.paginationBuffer.getRemainingPageCount(bufferKey, itemCountPerPage);
    console.log(`[StrategyPagination] parent=${bufferKey}, loadedPages=${loadedPages}, remainingPages=${remainingPages}, items=${appendedItems.length}, totalCount=${totalCount}`);
  }

  protected override onNavPaginationChildrenLoaded(
    _parentId: string,
    appendedItems: IBizEntity[],
    _knownEmptyFolderIds: string[]
  ): void {
    this.appendCachedChildren(appendedItems);
  }

  protected override async onContentPaginationChildrenLoaded(
    parentId: string,
    appendedItems: IBizEntity[]
  ): Promise<void> {
    if (parentId !== this.explorerContentAttributes.currentSelectedItem) {
      return;
    }

    this.appendCachedChildren(appendedItems);

    const existingItems = this.explorerContentAttributes.data || [];
    const itemsById = new Map(existingItems.map((item) => [item.id, item]));
    for (const item of appendedItems) {
      itemsById.set(item.id, item);
    }

    const children = Array.from(itemsById.values());
    this.explorerContentAttributes.data = children as any;
    await this.renderContentChildren(parentId, children);
  }

  private async defineExplorerContentAttributes(
    itemId: string = this.explorerAttributes.data.length > 0 ? this.explorerAttributes.data[0].id : '',
    preserveLoadedCount = false,
    loadedCountOverride = 0
  ): Promise<void>{
    const requestSequence = ++this.contentRequestSequence;
    const generation = this.paginationBuffer.getGeneration(itemId);
    const isCurrent = () => this._isActiveComponent && requestSequence === this.contentRequestSequence &&
      generation === this.paginationBuffer.getGeneration(itemId);
    // On a background refresh of the currently-open item, re-fetch as many items as were
    // already loaded (instead of just the first page) so the user's scroll position survives.
    const previouslyLoadedCount = this.paginationBuffer.getItems(itemId).length;
    const requestedLoadedCount = Math.max(previouslyLoadedCount, loadedCountOverride);
    const limit = preserveLoadedCount && requestedLoadedCount > this.contentItemCountPerPage
      ? requestedLoadedCount
      : this.contentItemCountPerPage;
    const page = await this.fetchPaginationPage(itemId, limit, 0);
    await this.explorerReveal.extendPage(itemId, page,
      offset => this.fetchPaginationPage(itemId, this.contentItemCountPerPage, offset), isCurrent);
    if (!isCurrent()) {
      return;
    }
    // A zero-total response means all raw pages were exhausted and no visible children exist.
    // Refresh the tree metadata so a speculative structural-folder chevron is removed.
    this.updateKnownEmptyFolder(itemId, page.items.length === 0 && page.totalCount === 0);
    this.paginationBuffer.setInitialPage(itemId, page);
    const children = page.items;
    this.appendCachedChildren(children);
    console.log(`[StrategyPagination] initial page for parent=${itemId}, rendered=${children.length}, totalCount=${page.totalCount}`);
    this.explorerContentAttributes.data = children as any;
    await this.renderContentChildren(itemId, children, requestSequence);
  }

  private async renderContentChildren(
    itemId: string,
    children: IBizEntity[],
    requestSequence?: number
  ): Promise<void> {
    if (requestSequence !== undefined && requestSequence !== this.contentRequestSequence) {
      return;
    }

    const flags = {
      containsStructuralBizEntity: children.some(e => e.type.category === BizEntityTypeCategory.Structural || e.type.category === BizEntityTypeCategory.BenzaitenObjective || e.type.functionType === BizEntityFunctionTypes.Structural),
      containsDeliverableBizEntity: children.some(e => e.type.category === BizEntityTypeCategory.BenzaitenDeliverable),
      containsOperationalBizEntity: children.some(e =>
        e.type.category === BizEntityTypeCategory.Operational ||
        e.type.functionType === BizEntityFunctionTypes.Operational
      )
    };

    let types:Set<BizEntityTypeCategory> = new Set();
    children.forEach(child => types.add(child.type.category));

    const colHeaders = getCombinedColHeadersForBizEntities(
      flags.containsStructuralBizEntity,
      flags.containsDeliverableBizEntity,
      false, // KPIs are excluded from the strategy explorer
      false, // Measures are excluded from the strategy explorer
      flags.containsOperationalBizEntity
    );

    // Lazy load deliverables only if needed
    if (children.some(c => c.type.category === BizEntityTypeCategory.BenzaitenDeliverable)) {
      const deliverableIds = children
        .filter(c => c.type.category === BizEntityTypeCategory.BenzaitenDeliverable)
        .map(c => c.id);
      this.dataLoadedOnce.deliverables = false; // Force reload of deliverables
      return this.ensureDeliverablesLoaded(deliverableIds)
        .then(() => {
          if (requestSequence !== undefined && requestSequence !== this.contentRequestSequence) {
            return;
          }
          this.explorerContentAttributes.listData = { 
            title: '', 
            colHeaders: colHeaders,
            items: this.prepareListData(itemId, children, colHeaders) as unknown as IListViewItem<IBizEntity>[],
            hasTableAutoInsertedRow: true 
          };
          this.explorerContentAttributes.entityHostItems = this.buildEntityHostItems(children);
          this.explorerComponent?.interceptListActions(this.explorerContentAttributes.listData);
        });
    } else {
      this.explorerContentAttributes.listData = { 
        title: '', 
        colHeaders: colHeaders,
        items: this.prepareListData(itemId, children, colHeaders) as unknown as IListViewItem<IBizEntity>[],
        hasTableAutoInsertedRow: true 
      };
      this.explorerContentAttributes.entityHostItems = this.buildEntityHostItems(children);
      this.explorerComponent?.interceptListActions(this.explorerContentAttributes.listData);
      return Promise.resolve();
    }
  }

  private defineExplorerContentGraphAttributes(itemId: string = this.explorerAttributes.data.find(id => !id.parentId)?.id || ''): void {
      // Assign data and the selected node ID
    this.explorerContentGraphAttributes.data = this.explorerAttributes.data;
    this.explorerContentGraphAttributes.data = this.utilService.filterOrphanData(this.explorerAttributes.data as IBizEntity[]);
    this.explorerContentGraphAttributes.currentSelectedNodeId = itemId;
    this.explorerContentGraphAttributes.graphConfig.cardLayout = getLayoutItemsForGraphView(this.explorerContentGraphAttributes.data,this.graphMenuButtonClicked, this.explorerAttributes.isInModal);
  }

  private prepareListData(itemId: string, children?: IBizEntity[], colHeaders?: IListViewColHeader[]): IListViewItem<IBizEntity>[] {
    // let selectedEntityChildren = this.extractItemChildren(itemId);
    // let listItems: IListViewItem<IBizEntity>[] = [];
    
    // if(selectedEntityChildren[0]?.type.category === BizEntityTypeCategory.BenzaitenDeliverable){
    //   // Deliverables should already be loaded by ensureDeliverablesLoaded()
    //   selectedEntityChildren = this.deliverables.filter((item) => item.parentId === itemId);
    //   let activeDeliverables = selectedEntityChildren as IDeliverable[];
    //   listItems = getListViewItemsForDeliverable(
    //     activeDeliverables, 
    //     this.menuButtonClicked, 
    //     this.itemClicked, 
    //     this.selectClickedItem, 
    //     this.isInModal, 
    //     this.onProgressBarSaveClicked
    //   );
    // } else {
    //   listItems = getListViewItemsForBizEntities(
    //     selectedEntityChildren, 
    //     this.menuButtonClicked, 
    //     this.itemClicked, 
    //     this.selectClickedItem, 
    //     this.isInModal
    //   );
    // }
    // return listItems;


    let items: IListViewItem<any>[] = [];

    const item = this.explorerAttributes.data.find(entity => entity.id === itemId);
    const contentChildren = children ?? [];
    const itemMap = new Map(items.map(i => [i.id, i]));

    if (contentChildren.length === 0) {
      return colHeaders
        ? normalizeListItems([], colHeaders)
        : [];
    }

    const tagDataPromise = this.getTagData(contentChildren);
    const bizEntityItems = getListViewItemsForBizEntities(
      contentChildren,
      this.menuButtonClicked,
      this.itemClicked,
      this.selectClickedItem,
      this.isInModal,
      tagDataPromise,
      this.linkedEntityPickerService,
      (entity, event) => {
        if (event instanceof MouseEvent) {
          this.notesPopover.openAt(event, String(entity.id), entity.name, entity);
        }
      },
      this.inlineNameEditHandlers
    );
    bizEntityItems.forEach(be => itemMap.set(be.id, be));

    if (
      // categories.has(BizEntityTypeCategory.BenzaitenDeliverable)
      contentChildren.some(c => c.type.category === BizEntityTypeCategory.BenzaitenDeliverable)
    ) {
      const activeDeliverables = this.deliverables.filter(d => contentChildren.some(c => c.id === d.id));
      const deliverableItems = getListViewItemsForDeliverable(
        activeDeliverables,
        this.menuButtonClicked,
        this.itemClicked,
        this.selectClickedItem,
          this.isInModal,
          this.onProgressBarSaveClicked,
          tagDataPromise,
          this.onProgressBarInteractionStarted,
          this.onProgressBarInteractionStarted,
          undefined,
          this.linkedEntityPickerService,
          this.inlineNameEditHandlers
        )
      deliverableItems.forEach(di => itemMap.set(di.id, di));
    }

    // Deliverable-specific rows replace generic rows; preserve their Notes action.
    for (const genericItem of bizEntityItems) {
      const specializedItem = itemMap.get(genericItem.id);
      const notesAction = genericItem.actions?.find(action => action.label === ColumnCanonicalKeys.Notes);
      if (specializedItem && specializedItem !== genericItem && notesAction &&
          !specializedItem.actions?.some(action => action.label === ColumnCanonicalKeys.Notes)) {
        specializedItem.actions = [...(specializedItem.actions ?? []), notesAction];
        const header = specializedItem.layout?.header;
        if (header && !header.actions?.some(action => action.label === ColumnCanonicalKeys.Notes)) {
          header.actions = [...(header.actions ?? []), notesAction];
        }
      }
    }

    // List builders write tags into the cell inputs in place after this resolves; the OnPush
    // lister never notices. setTimeout runs after the builders' .then write-backs, then a new
    // listData reference makes the lister re-check. Don't re-run interceptListActions — it isn't idempotent.
    tagDataPromise.finally(() => setTimeout(() => {
      this.explorerContentAttributes.listData = { ...this.explorerContentAttributes.listData };
    })).catch(() => {});

  //  CRITICAL FIX
    items = Array.from(itemMap.values());

    const normalizedItems = colHeaders
      ? normalizeListItems(items, colHeaders)
      : items;

    return normalizedItems;
  }

  private buildEntityHostItems(contentChildren: IBizEntity[]): IEntityHostGridItem[] {
    return contentChildren.map(entity => ({
      id: entity.id.toString(),
      // Deliverables need the hydrated copy (kpis/measure) from `this.deliverables`, not the raw explorer-tree entity.
      cardContent: this.buildCardContnent(this.deliverables.find(d => d.id.toString() === entity.id.toString()) ?? entity),
    }));
  }

  private buildCardContnent(entity: IBizEntity): IGridItemContent {
    return {
      component: EntityViewHostComponent,
      inputs: {
        entity,
        kind: ViewKind.Card,
        size: CardSize.Small,
      },
    };
  }

  /** Keyed off the emitting cards' own event constants, so a rename there is a compile error here instead of a silent miss. */
  private readonly entityHostEventHandlers: Record<string, (event: { id: string; type: string; payload?: unknown }) => void> = {
    [BenzaitenCardEvents.MenuOpened]: (event) => console.log('StrategyExplorer: card menuOpened', event),
  };

  /** Dispatches view-originated events bubbled up through EntityViewHostComponent -> Explorer. */
  onEntityHostCardEvent(event: { id: string; type: string; payload?: unknown }): void {
    const handler = this.entityHostEventHandlers[event.type];
    if (!handler) {
      console.log('StrategyExplorer: unhandled card event', event);
      return;
    }
    handler(event);
  }

  // Arrow function to maintain correct 'this' context when passed as callback
  // Handles progress bar save events for measure tracking
  onProgressBarSaveClicked = (key: string, id: string, progressValue: string, unit?: Unit): void => {
    // Ensure measures are loaded before accessing measureData
    this.ensureMeasuresLoaded([id])
      .then(() => {
        const measure = this.measureData.find(item => item.id.toString() === id.toString());
        // const log = createTxnLogJSON(key, progressValue, measure!, unit);
        // this.measureLogStateStoreService.create(log);
        if (measure) {
          handleDeliverableProgressSaveClicked(key, id, progressValue, measure, this.optimaDefaultModalService, this.measureLogStateStoreService,this.appStateService, this.toastService, unit);
        }
      })
      .catch((error) => {
        console.error('Error saving progress:', error);
      });
  }

  onProgressBarInteractionStarted = (key: string, id: string, progressValue: number, unit?: unknown): void => {
    this.ensureMeasuresLoaded([id])
      .then(() => {
        const measure = this.measureData.find(item => item.id.toString() === id.toString());
        if (!measure) {
          return;
        }

        const shouldCreateLogDirectly = shouldCreateDeliverableProgressLogDirectly(key, measure);
        if (!shouldCreateLogDirectly) {
          launchTransactionLogFormDialog(measure, this.optimaDefaultModalService, this.appStateService, this.measureLogStateStoreService, this.toastService);
        }
      })
      .catch((error) => {
        console.error('Error starting progress interaction:', error);
      });
  }

  // ===================== Off-Canvas & Actions =====================
  onActionButtonClicked(itemId: string) {
 
    this.appStateService.entityFormState = FormStates.Edit;
 
    const item = this.findDisplayedEntity(itemId);
    if (!item) {
      return;
    }
    this.appStateService.selectedBizEntityForEdit = item!;
    this.appStateService.selectedBizEntityTypeForNewBizEntity = this.appStateService.selectedBizEntityForEdit.type;
    this.openBizEntityFormInOffCanvas();
  }

  private openBizEntityFormInOffCanvas = () => {
    let comp: OffCanvasComponents | null = null;
    let shouldOpen = false;
    if (this.appStateService.entityFormState == FormStates.New) {
      // console.log("in constructor > For new, Selected biz entity type - " + this.appStateService.selectedBizEntityTypeForNewBizEntity?.name)
      const t = this.appStateService.selectedBizEntityTypeForNewBizEntity;
      comp = getOffCanvasComponentForBizEntityCategory(t ? t : undefined);
      if (comp !== null) {
        console.log(`[NEW] For BizEntity type ${t?.name}, component selected is - ` + getKeyOfEnumValue(comp, OffCanvasComponents));
        shouldOpen = true;
      } else {
        console.error("[NEW] No off-canvas component found for the selected biz entity type.");
      }
    } else if (this.appStateService.entityFormState == FormStates.Edit && this.appStateService.selectedBizEntityForEdit !== null) {
      const t = this.appStateService.selectedBizEntityForEdit.type;;
      comp = getOffCanvasComponentForBizEntityCategory(t ? t : undefined);
      if (comp !== null) {
        console.log(`[EDIT] For BizEntity type ${t?.name}, component selected is - ` + getKeyOfEnumValue(comp, OffCanvasComponents));
        shouldOpen = true;
      } else {
        console.error(`[EDIT] No off-canvas component found for ${t?.name}`);
      }
    }
    if (shouldOpen && comp !== null) {
      const level = this.offCanvasFormService.currentOffCanvas?.level ?? 0;
      openOffCanvas(this.offCanvasFormService, this.offCanvasServiceRef, comp, getOffCanvasIdFromLevel(level + 1), level + 1, true); //last param is important
    } else {
      this.appStateService.entityFormState = FormStates.Idle;
    }
  }

  private openOthersInRightOffCanvas = () => {
    if (this.appStateService.offCanvasRightContentType === OffCanvasRightContentTypes.Others) {
      const level = this.offCanvasFormService.currentOffCanvas?.level ?? 0;
      openOffCanvas(this.offCanvasFormService, this.offCanvasServiceRef, this.appStateService.offCanvasRightComponent, getOffCanvasIdFromLevel(level + 1), level + 1, false);
    }
  }
  private openDetailOffCanvas = () => {
    if(this.appStateService.offCanvasRightContentType === OffCanvasRightContentTypes.DetailForm){
      // Prefer the currently displayed API entity; fall back to the selected entity so View
      // also works for nodes visible only in the navigation tree.
      const selectedEntityId = this.appStateService.selectedBizEntityForEdit?.id;
      let entity = selectedEntityId
        ? this.findDisplayedEntity(selectedEntityId)
        : this.appStateService.selectedBizEntityForEdit ?? undefined;
      if(!entity){
        this.appStateService.entityFormState = FormStates.Idle;
        return;
      }
      this.appStateService.offCanvasDetailActiveFor = entity;
      this.entityBottomOffCanvasService.open(entity);
    }
  }

  // ===================== Inline Name Editing (list view) =====================

  /** Generic BizEntity rows get an inline-editable Name; see `isNameInlineEditable` for the rules. */
  private readonly inlineNameEditHandlers: IInlineNameEditHandlers = {
    onSave: (entity, col, previous) => this.onInlineNameSaved(entity, col, previous),
    onExpand: (entity) => this.onActionButtonClicked(String(entity.id)),
  };

  /**
   * The Lister has already put the edited text into `col.value` (optimistic). The value is validated
   * against the cell's field meta (BizEntityFormService, same rules as the full form) and saved by field
   * (`col.metaData.name`) to the store that owns the entity:
   * - Deliverable / Objective: their own state store, with the hydrated model (`this.deliverables` /
   *   `this.objectives`) patched by `BizEntityFormService.buildEntity`, as their forms do.
   * - Anything else (e.g. Department): `BizEntityFormService.submit()` → `BizEntityStateStoreService.update()`.
   * Success refreshes via the stores' `changed` subscriptions. An invalid value or a failed save restores
   * the cell, toasts and reloads the list.
   */
  onInlineNameSaved(entity: IBizEntity, col: IColsData<IBizEntity>, previous: string): void {
    const value = String(col.value ?? '').trim();
    col.value = value;
    if (value === previous) {
      return;
    }

    const revert = (message: string): void => {
      col.value = previous;
      this.toastService.toast(message);
      const currentSelectedItem = this.explorerContentAttributes.currentSelectedItem;
      if (currentSelectedItem) {
        this.updateListDataWithoutNavigation(currentSelectedItem);
      }
    };

    if (!this.bizEntityFormService.validateValue(value, col.metaData)) {
      revert(`${col.metaData.label} is not valid. The previous value was restored.`);
      return;
    }

    const id = String(entity.id);
    const values = { [col.metaData.name]: value };
    const category = entity.type?.category;

    let save: Promise<unknown>;
    if (category === BizEntityTypeCategory.BenzaitenDeliverable) {
      save = this.ensureDeliverablesLoaded([id]).then(() => {
        const deliverable = this.deliverables.find(d => String(d.id) === id);
        if (!deliverable) {
          throw new Error(`Deliverable ${id} is not loaded`);
        }
        const payload = this.bizEntityFormService.buildEntity(deliverable, values) as IDeliverable;
        return this.deliverableStateStoreService.update(payload) ?? Promise.reject(new Error('Deliverable store is not initialised'));
      });
    } else if (category === BizEntityTypeCategory.BenzaitenObjective) {
      save = this.ensureObjectivesLoaded([id]).then(() => {
        const objective = this.objectives.find(o => String(o.id) === id);
        if (!objective) {
          throw new Error(`Objective ${id} is not loaded`);
        }
        const payload = this.bizEntityFormService.buildEntity(objective, values) as IObjective;
        return this.objectiveStateStoreService.update(payload) ?? Promise.reject(new Error('Objective store is not initialised'));
      });
    } else {
      save = this.bizEntityFormService.submit(entity, values);
    }

    save.catch(() => revert(`Could not save ${col.metaData.label}. The previous value was restored.`));
  }

  // ===================== List Item Interactions =====================

  // Arrow function to maintain correct 'this' context when passed as callback
  private menuButtonClicked = (item: IListViewItem<IBizEntity> | undefined, event?: Event) => { }
  private graphMenuButtonClicked = (item: ILayout<IBizEntity> | undefined, event?: Event) => { }
  // Arrow function to maintain correct 'this' context when passed as callback
  selectClickedItem = (itemId: string) => {
    if (this.isInModal) {
      this._selectedEntity = this.findDisplayedEntity(itemId) as any;
    }
  }

  /**
   * ============================ HOTFIX - TEMPORARY WORKAROUND ============================
   * TODO (next sprint): replace this with a proper single-owner design for grid double-click.
   *
   * WHY THIS EXISTS
   * In grid view one double-click fires `dblclick` on TWO listeners that both open the detail view:
   *   1. The card itself:      `(dblclick)="onCardDoubleClicked()"` in the card templates / CardViewBase.
   *   2. The explorer wrapper: `(dblclick)` in explorer-content-entity-host -> this handler -> itemClicked().
   * Result: two detail off-canvases for one gesture.
   *
   * WHAT IT DOES
   * For Deliverable and KPI cards the card already opens the detail view, so we skip the wrapper's
   * path for them. Every other entity still goes through `itemClicked` (drill down / open detail).
   *
   * WARNINGS
   *  - This hardcodes "the card handles these categories" inside the explorer. If a card stops handling
   *    double-click (or a new category's card starts to), this must be updated by hand or the
   *    detail view will open twice / not at all.
   *  - Only the STRATEGY explorer is patched. Any other host that mounts these cards AND has a
   *    wrapper double-click handler will have the same bug.
   *  - Deliverable/KPI double-click in grid view no longer goes through `itemClicked`, so it will not
   *    drill into children; it only opens the detail view (same as the card does on the dashboard).
   *  - Proper fix: make the card only REPORT the double-click (emit a view event) and let each host
   *    (dashboard / explorer) decide what it means, so there is exactly one owner per gesture.
   * ======================================================================================
   */
  onEntityHostItemDoubleClicked = (itemId: string) => {
    const category = this.findDisplayedEntity(itemId)?.type?.category;
    if (category === BizEntityTypeCategory.BenzaitenDeliverable || category === BizEntityTypeCategory.BenzaitenKPI) {
      return;
    }
    this.itemClicked(itemId);
  }

  // Arrow function to maintain correct 'this' context when passed as callback
  itemClicked = (itemId: string, actionOnOperationalElementClicked: boolean = true) => {
    this.lastVisitedItemId = itemId;
    this.subHeaderAttributes.previouseDisable = false;
    const item = this.findDisplayedEntity(itemId);
    const isOperationalLeaf = item?.type.functionType === BizEntityFunctionTypes.Operational &&
      item.type.category !== BizEntityTypeCategory.BenzaitenMeasure &&
      item.type.category !== BizEntityTypeCategory.BenzaitenObjective &&
      this.extractItemChildren(itemId).length === 0;
    if (isOperationalLeaf && actionOnOperationalElementClicked) {
      if(!this.isInModal){
        if(item){
          // this.appStateService.selectedBizEntityForEdit = item;
          this.appStateService.offCanvasDetailActiveFor = item;
          // let component:OffCanvasComponents;
          
          // if(item.type.category === BizEntityTypeCategory.BenzaitenKPI){
          //   component = OffCanvasComponents.KPIDetail;
          // }
          // else if(item.type.category === BizEntityTypeCategory.BenzaitenDeliverable){
          //   component = OffCanvasComponents.DeliverableDetail;
          // }
          // else{
          //   component = OffCanvasComponents.DeliverableDetail
          // }
          this.entityBottomOffCanvasService.open(item);
        }
      }
      return
    } 

    this.isLoading.set(true);
    
    this.updateListData(itemId)
      .then(() => {
        this.isLoading.set(false);
      })
      .catch((error) => {
        console.error('Error updating list data:', error);
        this.isLoading.set(false);
      });
    this.resetIncomingBizEntitySelectionId();
  }

  get data(): IBizEntity | null {
    return this._selectedEntity;
  }

  // ===================== Context Menu =====================

  processContentContextMenuClicked(event: ContextMenuClickInfo): void {
    const { id: itemId, event: domEvent } = event;
    if (!itemId) {
      console.error('Invalid item ID.');
      return;
    }

    const bizEntityItem = this.findDisplayedEntity(itemId);
    this.contextMenuService.applyTemplateEvent.emit(bizEntityItem!);
    this.appStateService.selectedBizEntityForEdit = bizEntityItem!;
    this.contextMenuService.bizEnitityEvent.emit(bizEntityItem);
    
    if (bizEntityItem && bizEntityItem.type) {
      this.updateContextMenuList(bizEntityItem, [...this.contextMenuItems]); 
    }
  }
  
  updateContextMenuList(entity: IBizEntity, menuItems: ContextMenuItem[]): void {
    const list = this.contextMenuService.getEntityListBasedOnType(entity, menuItems);
    this.explorerAttributes.contextMenuItems = list;

    // When the "Cross App" option is present, fetch the related entities for each
    // cross-app relationship target type asynchronously and reassign a NEW array
    // reference so an already-open context menu re-renders with the populated
    // sub-items.
    this.contextMenuService.populateCrossAppSubItems(entity, list).then(updatedList => {
      if (updatedList) {
        this.explorerAttributes.contextMenuItems = updatedList;
      }
    });
  }

  // ===================== Utility Methods =====================

  addToQuickActionClicked(): void {
     let itemClicked = this.appStateService.selectedBizEntityForEdit;
    if(itemClicked && itemClicked.type.category === BizEntityTypeCategory.BenzaitenDeliverable){
      let deliverable = this.deliverables.find(entity => entity.id === itemClicked?.id)!;
      this.quickActionMockService.pushToStatus(deliverable, this.onProgressBarSaveClicked);
    }
  }

  resetIncomingBizEntitySelectionId(): void {
    this.appStateService.incomingBizEntitySelectionId = null;
  }

  markDeliverableAsComplete(bizEntity: IBizEntity): void {
    const deliverable = this.deliverables.find(d => d.id.toString() === bizEntity.id.toString());
    if(deliverable){
      // console.log('Marking deliverable as complete:', deliverable);
      markDeliverableAsComplete(this.deliverableStateStoreService, deliverable, this.toastService);
    }
    
  }

  private getTagData(entities: IBizEntity[]) {
    const entityIds = entities.map((entity) => entity.id);
    return Promise.all([
      this.appTagService.getAvailableTags(),
      this.appTagService.getSystemTagBizEntityType(),
      this.appTagService.getAssignedTags(entityIds),
    ]).then(([availableTagsFromAPI, tagBizEntityTypeFromAPI, parentAssignedTagsFromAPI]) => ({
      availableTagsFromAPI,
      tagBizEntityTypeFromAPI,
      parentAssignedTagsFromAPI,
    }));
  }
}